"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeObservabilityTag = void 0;
const serializeObservabilityTag = (tag, value) => {
    return `${tag}${value !== undefined ? `:${value}` : ""}`;
};
exports.serializeObservabilityTag = serializeObservabilityTag;
//# sourceMappingURL=serializezObservabilityTag.js.map